import { FC } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { alpha, Box, Chip, Tooltip } from "@mui/material";
import { objColorsChipsFunctionProducer } from "src/shared/ColorObj/ColorsChipsFunctionProducer";

export type TQuickProducerFilterId = "CORRETOR" | "SUPERVISOR" | "GERENTE";

interface IQuickFiltersProducer {
  activeFilter?: TQuickProducerFilterId;
  onFilterToggle: (filterId: TQuickProducerFilterId) => void;
  onClearFilters: () => void;
}

const quickFilterOptions: {
  id: TQuickProducerFilterId;
  label: string;
  tooltip: string;
}[] = [
    {
      id: "CORRETOR",
      label: "Corretor",
      tooltip: "Filtrar somente produtores com função Corretor",
    },
    {
      id: "SUPERVISOR",
      label: "Supervisor",
      tooltip: "Filtrar somente produtores com função Supervisor",
    },
    {
      id: "GERENTE",
      label: "Gerente",
      tooltip: "Filtrar somente produtores com função Gerente",
    },
  ];

export const QuickFiltersProducer: FC<IQuickFiltersProducer> = ({
  activeFilter,
  onFilterToggle,
  onClearFilters,
}) => {
  const hasActiveFilter = Boolean(activeFilter);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {quickFilterOptions.map((option) => {
        const active = activeFilter === option.id;
        const optionColor = objColorsChipsFunctionProducer[option.id].color;

        return (
          <Tooltip key={option.id} title={option.tooltip} arrow>
            <Chip
              icon={objColorsChipsFunctionProducer[option.id].icon}
              label={option.label}
              variant={active ? "filled" : "outlined"}
              onClick={() => onFilterToggle(option.id)}
              sx={{
                cursor: "pointer",
                fontWeight: active ? 600 : 400,
                color: active ? optionColor : "text.secondary",
                borderColor: active ? "transparent" : "divider",
                backgroundColor: active ? alpha(optionColor, 0.12) : "transparent",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  transform: "translateY(-1px)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                },
              }}
            />
          </Tooltip>
        );
      })}

      {hasActiveFilter && (
        <Tooltip title="Limpar filtro rápido de função" arrow>
          <Chip
            icon={<RefreshIcon sx={{ fontSize: "1rem" }} />}
            label="Limpar"
            variant="outlined"
            onClick={onClearFilters}
            sx={{
              cursor: "pointer",
              borderStyle: "dashed",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.04)",
              },
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
};
